import { connect } from 'react-redux';

import { selectors, actions } from 'modules/configure';
import type { Dispatch, State } from 'model/State';
import {
  makeSelectProductTiers,
  makeSelectProductName,
  makeSelectProductDescription,
  makeIsMarketplaceAddon,
  makeSelectProductMoreLink,
} from 'modules/catalog/pricing';
import type { OwnProps, StateProps, DispatchProps } from 'components/common/ProductListRow';
import ProductListRow from 'components/common/ProductListRow';
import selectCurrency from 'modules/cart/duck/selectors/currency';
import { getProduct } from '../../../data/products';

const makeMapStateToProps = () => {
  const selectProductTiers = makeSelectProductTiers();
  const selectAddonTier = selectors.makeSelectAddonTier();
  const selectProductName = makeSelectProductName();
  const selectProductDescription = makeSelectProductDescription();
  const isMarketplaceAddon = makeIsMarketplaceAddon();
  const selectProductExternalUrl = makeSelectProductMoreLink();

  return (state: State, ownProps: OwnProps): StateProps => ({
    currency: selectCurrency(state).result as unknown as string,
    productName: selectProductName(state, ownProps) as string,
    selected: selectors.isProductSelected(state, ownProps),
    tiers: selectProductTiers(state, ownProps),
    tier: selectAddonTier(state, ownProps),
    child: selectors.isChildProduct(state, ownProps),
    // @ts-ignore
    subscription: selectors.isSubscription(state, ownProps),
    expanded: selectors.isExpanded(state, ownProps),
    description: selectProductDescription(state, ownProps),
    marketplaceAddon: isMarketplaceAddon(state, ownProps),
    externalUrl: selectProductExternalUrl(state, ownProps) ?? '',
    additionalTierLabel: getProduct(ownProps.productKey)
      ? getProduct(ownProps.productKey)?.additionalTierLabel
      : null,
  });
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps): DispatchProps => ({
  onAddonToggle: () => dispatch(actions.toggleAddon(ownProps.productKey)),
  onTierSelect: (productKey, tier) => dispatch(actions.selectProductTier(productKey, tier)),
  onAddonExpand: () => dispatch(actions.toggleAddonExpanded(ownProps.productKey)),
});

export default connect(makeMapStateToProps, mapDispatchToProps)(ProductListRow);
